/**
 *
 * https://hacks.mozilla.org/2012/02/storing-images-and-files-in-indexeddb/
 *
 */
angular.module('app', ['ui.router', 'ngResource', 'ngHolder', 'ui.select', 'ngSanitize', 'ngCookies', 'pascalprecht.translate'])
.constant('ME_CONFIG', {
    baseUrl: 'me_build_version'.toUpperCase() !== '1776383249234' ?
        'https://app.marginedge.com' : 'http://localhost:8080'
})
.constant('ME_BUILD', {
    url: 'me_build_version'.toUpperCase() !== '1776383249234' ?
        '1776383249234' + '/' : ''
})
.constant('AUTH0_CONFIG', {
    // default to dev values (find in auth0_config.json)
    domain: 'me_build_version'.toUpperCase() !== '1776383249234' ?
        'auth.marginedge.com' : 'auth-dev.dev.marginedge.com',
    clientId: 'me_build_version'.toUpperCase() !== '1776383249234' ?
        'typ0CIMWokcXW4nUYXGlSjZ4gpR60rw9' : 'qbJrXBf70PqzQAAvZz2Ol6J5omk6Ms9G',
    connection: 'me_build_version'.toUpperCase() !== '1776383249234' ?
        'MarginEdge' : 'MarginEdge',
    audience: 'me_build_version'.toUpperCase() !== '1776383249234' ?
        'https://app.marginedge.com/' : 'http://localhost:8090/'
})
.constant('LOCALE_CONFIG', {
    LANG_TO_LOCALE_MAP: {
        en: {
            bootBox: 'en',
            marginEdge: 'en'
        },
        fr: {
            bootBox: 'fr',
            marginEdge: 'fr'
        },
        es_US: {
            bootBox: 'es',
            marginEdge: 'es_US'
        }
    }
})
.config(['$stateProvider', '$urlRouterProvider', '$httpProvider', 'ME_BUILD', 'ME_CONFIG', function($stateProvider, $urlRouterProvider, $httpProvider, ME_BUILD, ME_CONFIG) {
    // Initialize our API base URL
    ME_CONFIG.apiBaseUrl = ME_CONFIG.baseUrl + '/api';
    
    // Initialize our assets URL
    ME_BUILD.templateUrl = function(url) {
        return ME_BUILD.url ? ME_BUILD.url + url : url;
    };

    $httpProvider.interceptors.push('SessionInjector');

    $urlRouterProvider.otherwise('/category/');

    $stateProvider
    .state('login', {
        url: '/login',
        templateUrl: ME_BUILD.templateUrl('view/login.html'),
        controller: 'LoginController'
    })
    .state('error', {
        url: '/error',
        templateUrl: ME_BUILD.templateUrl('view/error.html')
    })
    .state('auth', {
        url: '/auth',
        controller: 'Auth0LoginController',
        templateUrl: ME_BUILD.templateUrl('view/auth0Login.html')
    })
    .state('outage', {
        url: '/outage',
        templateUrl: ME_BUILD.templateUrl('view/outage.html')
    })
    .state('root', {
        abstract: true,
        templateUrl: ME_BUILD.templateUrl('view/root.html'),
        controller: 'RootController'
    })
    .state('recipe', {
        parent: 'root',
        url: '/recipe/:id',
        templateUrl: ME_BUILD.templateUrl('view/recipe.html'),
        controller: 'RecipeController'
    })
    .state('print', {
        parent: 'root',
        url: '/recipe/:id/print',
        templateUrl: ME_BUILD.templateUrl('view/print.html'),
        controller: 'PrintController',
        resolve: {
            PreviousPageInfo: ["$state", function ($state) {
                return {
                    url: $state.href($state.current.name, $state.params),
                    name: $state.current.name,
                    params: _.assign({}, $state.params)
                };
            }]
        }
    })
    .state('printTimestamp', {
        parent: 'root',
        url: '/printTimestamp',
        templateUrl: ME_BUILD.templateUrl('view/printTimestamp.html'),
        controller: 'PrintController',
        resolve: {
            PreviousPageInfo: ["$state", function ($state) {
                return {
                    url: $state.href($state.current.name, $state.params),
                    name: $state.current.name,
                    params: _.assign({}, $state.params)
                };
            }]
        }
    })
    .state('printerConfig', {
        parent: 'root',
        url: '/printConfig',
        templateUrl: ME_BUILD.templateUrl('view/printerConfig.html'),
        controller: 'PrinterConfigController'
    })
    .state('printHistory', {
        parent: 'root',
        url: '/recipe/:id/print/history',
        templateUrl: ME_BUILD.templateUrl('view/printHistory.html'),
        controller: 'PrintHistoryController'
    })
    .state('category', {
        parent: 'root',
        url: '/category/:id',
        templateUrl: ME_BUILD.templateUrl('view/category.html'),
        controller: 'CategoryController'
    })
    .state('type', {
        parent: 'root',
        url: '/type/:id',
        templateUrl: ME_BUILD.templateUrl('view/type.html'),
        controller: 'TypeController'
    })
    .state('search', {
        parent: 'root',
        url: '/search',
        templateUrl: ME_BUILD.templateUrl('view/search.html'),
        controller: 'SearchController'
    })
    .state('switch', {
        parent: 'root',
        url: '/switch?id&name',
        templateUrl: ME_BUILD.templateUrl('view/switch.html'),
        controller: 'SwitchController'
    })
    .state('recipeUtensils', {
        parent: 'root',
        url: '/recipe/:id/utensils',
        templateUrl: ME_BUILD.templateUrl('view/recipeUtensils.html'),
        controller: 'RecipeUtensilController'
    });
}])
.config(['$translateProvider', 'ME_BUILD', 'LOCALE_CONFIG', function($translateProvider, ME_BUILD, LOCALE_CONFIG) {
    $translateProvider
        .registerAvailableLanguageKeys(['en', 'fr', 'es'], {
            'en_US': 'en',
            'en-*': 'en',
            'es_US': 'es',
            'es-*': 'es',
            'fr': 'fr',
            'fr-CA': 'fr',
            'fr_*': 'fr'
        })
        .useStaticFilesLoader({
            prefix: ME_BUILD.url + 'locales/',
            suffix: '.json'
        })
        .determinePreferredLanguage();
    
    $translateProvider.useSanitizeValueStrategy('escaped');
    $translateProvider.preferredLanguage(LOCALE_CONFIG.LANG_TO_LOCALE_MAP.en.marginEdge);
    $translateProvider.fallbackLanguage(LOCALE_CONFIG.LANG_TO_LOCALE_MAP.en.marginEdge);
    $translateProvider.useCookieStorage(); // save/read from cookie
}])
.service('ConfigService', ['$rootScope', '$state', '$location', 'AUTH0_CONFIG', function($rootScope, $state, $location, AUTH0_CONFIG) {
    
    // https://stackoverflow.com/a/2117523
    var generateUuid = function() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    var init = function() {
        var uuid = localStorage && localStorage.getItem('ME_UUID');
        if(uuid) {
            return;
        }

        if(localStorage) {
            localStorage.setItem('ME_UUID', generateUuid());
        }
    };
    this.init = init;

    var getUuid = function() {
        return localStorage && localStorage.getItem('ME_UUID');
    };
    this.getUuid = getUuid;

    var setToken = function(token) {
        if(token) {
            localStorage.setItem('ME_TOKEN', JSON.stringify(token));
        }
        else {
            localStorage.removeItem('ME_TOKEN');
        }
    };
    this.setToken = setToken;

    var getToken = function() {
        var rawToken = localStorage.getItem('ME_TOKEN');
        return rawToken && JSON.parse(rawToken);
    };
    this.getToken = getToken;
    
    var setRestaurantUnit = function(u) {
        if(u) {
            localStorage.setItem('ME_RESTAURANT_UNIT', JSON.stringify(u));
        }
        else {
            localStorage.removeItem('ME_RESTAURANT_UNIT');
        }
    };
    this.setRestaurantUnit = setRestaurantUnit;
    
    var getRestaurantUnit = function() {
        var u = localStorage.getItem('ME_RESTAURANT_UNIT');
        return u && JSON.parse(u);
    };
    this.getRestaurantUnit = getRestaurantUnit;

    var getCurrentRecipeViewerUrl = function () {
        return $location.absUrl()
            // remove any mention of code and state from url
            .replace(/(.*)\?(?:code|state|error)=.*(#!.*)/, "$1$2")
            // remove the path to get root url
            .replace($location.path(), '/');
    };
    this.getCurrentRecipeViewerUrl = getCurrentRecipeViewerUrl;
    
    var logout = function() {
        // clear local storage
        setToken();
        
        // check if we have an auth0 token stored (only locally)
        $rootScope.auth0Client
            .getTokenSilently({
                cacheMode: 'cache-only',
                authorizationParams: {
                    audience: AUTH0_CONFIG.audience
                }
            })
            .then(function (token) {

                if (token) {
                    // if we have an auth0 token, logout through auth0
                    $rootScope.auth0Client.logout({
                        logoutParams: {
                            returnTo: getCurrentRecipeViewerUrl()
                        }
                    });

                } else {
                    // not authenticated through Auth0... move to login page
                    $state.go('login');
                }
            }).catch(function () {
                // something funky getting a token from Auth0, just move to login
                $state.go('login');
        });
        
    }
    this.logout = logout;
}])
.service('UnitService', ['Unit', '$filter', '$translate', function(Unit, $filter, $translate) {
    var unitsOfMeasure = undefined;

    var init = function() {
        if(unitsOfMeasure) {
            return;
        }

        Unit.query().$promise
        .then(function(results) {
            unitsOfMeasure = _.sortBy(results, 'name');
        });
    };
    this.init = init;

    var findUnit = function(name) {
        return name && _.find(unitsOfMeasure, { name: name });
    };
    this.findUnit = findUnit;

    var getQuantityUnitDisplay = function(item) {
        if( ! (item && item.unit && _.isFinite(item.quantity))) {
            return '';
        }

        var unit = findUnit(item.unit);
        if( ! unit) {
            return '';
        }
        
        var friendlyName = item.quantity === 1 ? $translate.instant(unit.translationKeySingular) : $translate.instant(unit.translationKeyPlural);

        if(item.quantityDisplay && String(item.quantityDisplay).includes('/') && String(item.quantityDisplay).match(/^[0-9./]+$/)) {
            return item.quantityDisplay + ' (' + $filter('number')(item.quantity) + ') ' + friendlyName;
        }

        return $filter('number')(item.quantity) + ' ' + friendlyName;
    };
    this.getQuantityUnitDisplay = getQuantityUnitDisplay;
}])
.service('i18nService', ['$translate', '$cookies', 'LOCALE_CONFIG',function($translate, $cookies, LOCALE_CONFIG) {
    return {
        setLanguage: function(langKey) {
            var locale = LOCALE_CONFIG.LANG_TO_LOCALE_MAP[langKey] ? LOCALE_CONFIG.LANG_TO_LOCALE_MAP[langKey] : LOCALE_CONFIG.LANG_TO_LOCALE_MAP.en;
            
            $translate.use(locale.marginEdge);
            $cookies.put('NG_TRANSLATE_LANG_KEY', locale.marginEdge.replace(/"/g, ''));
            
            $translate.refresh().then(function () {
                bootbox.setDefaults({
                    /**
                     * @optional String
                     * @default: en
                     * which locale settings to use to translate the three
                     * standard button labels: OK, CONFIRM, CANCEL
                     */
                    locale: locale.bootBox
                });
            });
        },

        detectAndSetInitialLanguage: function() {
            var langKey = $cookies.get('NG_TRANSLATE_LANG_KEY');
            if (langKey) {
                langKey = langKey.replace(/^"|"$/g, ''); // Strip quotes
            } else {
                langKey = (navigator.language || navigator.userLanguage || 'en').split('-')[0];
            }
            var language = this.cookieOrBrowserLanguageToMELanguageHelper(langKey);
            this.setLanguage(language);
        },
        
        cookieOrBrowserLanguageToMELanguageHelper: function (language) {
            // for our non-english languages, the options that the browser returns are either the exact language `fr` or `es`
            // or the lang-locale such as `fr-ca` or `es-us`. We need to convert the browser language to the language key we have in ME
            // we'll accept any locale for these languages or an exact match - otherwise english
            
            // if language contains fr- or equals fr then it is french
            if (language === 'fr' || language.indexOf('fr-') > -1) {
                return LOCALE_CONFIG.LANG_TO_LOCALE_MAP.fr.marginEdge;
            } else if (language === 'es' || language.indexOf('es-') > -1 || language.indexOf('es_') > -1) {
                // if language contains es- or es_ or equals es then it is spanish
                return LOCALE_CONFIG.LANG_TO_LOCALE_MAP.es_US.marginEdge;
            }
            // anything else, return english
            return LOCALE_CONFIG.LANG_TO_LOCALE_MAP.en.marginEdge;
        }
    };
}])
.service('SessionInjector', ['$q', '$location', 'ConfigService', 'ME_CONFIG', function($q, $location, ConfigService, ME_CONFIG) {
    this.request = function(c) {
        if( ! (c && c.url && c.url.indexOf(ME_CONFIG.apiBaseUrl) === 0)) {
            return c;
        }

        var tokenData = ConfigService.getToken();
        if(tokenData && tokenData.access_token) {
            c.headers['Authorization'] = 'Bearer ' + tokenData.access_token;
        }
        return c;
    };

    var getErrorRedirect = function(r) {
        // Is this one of our API calls?
        if( ! (r.config && r.config.url && r.config.url.indexOf(ME_CONFIG.apiBaseUrl) === 0)) {
            return undefined;
        }
        
        // Missing entity; go home 
        if(r.status === 404) {
            return '/category';
        }
        
        // Unauthorized; be sure to clear auth info and move to login
        if(r.status === 401) {
            return ConfigService.logout();
        }
        
        if(r.status === 503) {
            return '/outage';
        }
        
        // No data; be sure to clear auth info and move to login
        if( ! r.data) {
            return ConfigService.logout();
        }
        
        // Invalid token; be sure to clear auth info and move to login
        if(r.data.error === 'invalid_token') {
            return ConfigService.logout();
        }

        // No token; be sure to clear auth info and move to login
        if( ! ConfigService.getToken()) {
            return ConfigService.logout();
        }
        
        // Nothing special
        return undefined;
    };

    this.responseError = function(r) {
        var redirectTo = getErrorRedirect(r);
        if(redirectTo) {
            $location.url(redirectTo);
            return $q.reject();
        }
    };
}])
.filter('quantityUnitFilter', ['UnitService', function(UnitService) {
    return UnitService.getQuantityUnitDisplay;
}])
.filter('booleanFilter', ['$translate', function ($translate) {
    return function (input) {
        if (input === true) {
            return $translate.instant('recipeViewer.action.true');
        } else if (_.isNil(input)) {
            return '';
        } else {
            return $translate.instant('recipeViewer.action.false');
        }
    };
}])
.filter('trusted', ['$sce', function ($sce) {
    return function(url) {
        return $sce.trustAsResourceUrl(url);
    };
}])
.factory('User', ['$resource', 'ME_CONFIG', function($resource, ME_CONFIG) {
    return $resource(ME_CONFIG.apiBaseUrl + '/users/:id', { }, {
        switchUnit: {
            method: 'PUT',
            url: ME_CONFIG.apiBaseUrl + '/users/switchUnit'
        }
    });
}])
.factory('AppConfig', ['$resource', 'ME_CONFIG', function($resource, ME_CONFIG) {
    return $resource(ME_CONFIG.apiBaseUrl + '/appConfig/useNewLoginPath', { }, {
        useNewLoginPath: {
            method: 'GET',
            url: ME_CONFIG.apiBaseUrl + '/central/appConfig/useNewLoginPath',
            transformResponse: function (data) {
                return {
                    enabled: angular.fromJson(data)
                };
            }
        }
    });
}])
.factory('RestaurantUnit', ['$resource', 'ME_CONFIG', function($resource, ME_CONFIG) {
    return $resource(ME_CONFIG.apiBaseUrl + '/restaurantunits/:id', { }, {
        mine: {
            method: 'GET',
            url: ME_CONFIG.apiBaseUrl + '/restaurantunits/mine',
            isArray: true
        },
        current: {
            method: 'GET',
            url: ME_CONFIG.apiBaseUrl + '/restaurantunits/current',
            isArray: false
        }
    });
}])
.factory('Unit', ['$resource', 'ME_CONFIG', function($resource, ME_CONFIG) {
    return $resource(ME_CONFIG.apiBaseUrl + '/units/:id', { }, {
        'query': {
            method: 'GET',
            isArray: true,
            transformResponse: function(data) {
                return data && angular.fromJson(data) || [ ];
            }
        }
    });
}])
.factory('Allergen', ['$resource', 'ME_CONFIG', function($resource, ME_CONFIG) {
    return $resource(ME_CONFIG.apiBaseUrl + '/allergens/:id', { }, {
        'query': {
            method: 'GET',
            isArray: true,
            transformResponse: function(data) {
                return data && angular.fromJson(data) || [ ];
            }
        }
    });
}])
.factory('Feature', ['$resource', 'ME_CONFIG', function($resource, ME_CONFIG) {
     return $resource(ME_CONFIG.apiBaseUrl + '/featureFlags/', {}, {
         'query': { method: 'GET', isArray: true}
     });
}])
.factory('Account', ['$resource', 'ME_CONFIG', function ($resource, ME_CONFIG) {
    return $resource(ME_CONFIG.apiBaseUrl + '/account', {}, {
        'query': {method: 'GET'}
    });
}])
.controller('RootController', ['$rootScope', '$scope', 'ConfigService', 'RecipeService', 'Feature', 'Account', 'i18nService', function($rootScope, $scope, ConfigService, RecipeService, Feature, Account, i18nService) {
    
    // set the initial language either from cookie or from browser settings
    i18nService.detectAndSetInitialLanguage();
    
    $scope.mobile = $('button.navbar-toggle').is(':visible');
    $(window).on('resize', _.debounce(function() {
        $scope.$apply(function() {
            $scope.mobile = $('button.navbar-toggle').is(':visible');
        });
    }, 300));
    $scope.categories = RecipeService.getCategories();
    $scope.restaurantUnit = ConfigService.getRestaurantUnit;

    $scope.logout = ConfigService.logout;

    Account.query().$promise.then(function(userInfo) {
        i18nService.setLanguage(userInfo.langKey);
    });
    
    Feature.query().$promise.then(function(results) {
        $scope.featureFlags = results;
        // Setting flag to true if feature flag is turned on for the unit
        $rootScope.showPrinterLabel = !!(_.find($scope.featureFlags, { "name":"PRINTER_LABEL", "active":true}));
    });
    
}])
.controller('LoginController', ['$scope', '$http', '$state', 'ME_CONFIG', 'ConfigService', 'UnitService', 'RestaurantUnit', 'AppConfig', 
    function($scope, $http, $state, ME_CONFIG, ConfigService, UnitService, RestaurantUnit, AppConfig) {
    // Clear
    ConfigService.setToken();

    $scope.decidingLoginPath = true;
    // for unauthenticated users, we first want to check if we want to route to Auth0
    // if we don't, we'll just continue with the legacy login process
    AppConfig.useNewLoginPath().$promise
        .then(function (appConfigResult) {
            // if it is, we'll redirect to Auth0
            if (appConfigResult.enabled) {
                // away we go to Auth0!
                $state.go('auth');
            } else {
                // otherwise proceed with the legacy path!
                $scope.decidingLoginPath = false;
            }
        })
        // we don't want a finally here. We don't want to hit the finally mid-redirect and show the login screen for a flash
        .catch(function () {
            $state.go('error');
        });

    $scope.login = function() {
        $scope.loginDisabled = true;
        $scope.error = false;

        var uuid = ConfigService.getUuid();

        var data = "username=" + encodeURIComponent($scope.username) + "&password="
            + encodeURIComponent($scope.password) + "&grant_type=password&scope=read%20write&" +
            "client_secret=mySecretOAuthSecret&client_id=inviosoapp&uuid=" + uuid;

        $http({
            method: 'POST',
            url: ME_CONFIG.baseUrl + '/oauth/token',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json",
                "Authorization": "Basic " + btoa("inviosoapp" + ':' + "mySecretOAuthSecret")
            },
            data: data
        })
        .then(function(response) {
            var s = response && response.status;
            var d = response && response.data;
            if( ! (s === 200 && d && d.access_token)) {
                $scope.error = true;
                return;
            }

            d.expires_at = (new Date()).getTime() + d.expires_in;

            ConfigService.setToken(d);
            
            RestaurantUnit.mine().$promise
            .then(function(data) {
                var unit = _.chain(data)
                .filter({ current: true })
                .map(function(u) {
                    return { id: u.id, name: u.name };
                })
                .head()
                .value();
                ConfigService.setRestaurantUnit(unit);
            });

            $state.go('category', { id: '' });
        })
        .catch(function() {
            $scope.error = true;
        })
        .finally(function() {
            if(ConfigService.getToken()) {
                UnitService.init();
            }
            $scope.loginDisabled = false;
        });
    };
}])
.controller('RecipeUtensilController', ['$scope', '$stateParams', 'Recipe', function($scope, $stateParams, Recipe) {
    $scope.recipe = Recipe.get({ id: $stateParams.id });
}])
.controller('CategoryController', ['$rootScope', '$scope', '$state', '$stateParams', '$translate', 'Recipe', 'RecipeService', 'PrinterConfig', '$q', 'Feature', function($rootScope, $scope, $state, $stateParams, $translate, Recipe, RecipeService, PrinterConfig, $q, Feature) {
    var promises = [Recipe.query().$promise, PrinterConfig.current().$promise, Feature.query().$promise];
    $q.all(promises).then(function(results) {
        var recipeData = results[0];
        $scope.category = _.find(RecipeService.getCategories(), { id: ($stateParams.id || '') });
        $scope.featureFlags = results[2];
        // Setting flag to true if feature flag is turned on for the unit
        $rootScope.showPrinterLabel = !!(_.find($scope.featureFlags, { "name":"PRINTER_LABEL", "active":true}));
        if( ! $scope.category) {
            $state.go('category', { id: '' });
            return;
        }
        var restaurantUnitID = Number($scope.restaurantUnit().id);
        recipeData = RecipeService.restrictedTenantFilter(recipeData, restaurantUnitID);
        $scope.recipes = $stateParams.id ?
            _.filter(recipeData, function (item) {
                return (_.get(item, 'type.category') === $stateParams.id || _.get(item, 'category') === $stateParams.id)
            }) :
            recipeData;
        $scope.types = _.chain($scope.recipes).map('type').uniqBy('id').sortBy('name').value();
        $scope.printerConfig = results[1];
        $scope.hasPrinterConfig = !_.isNil(_.get($scope.printerConfig, 'printerIpAddress'));
        
        $scope.getTranslatedCategoryName = function (category) {
            return $translate.instant(category.translationKey);
        };
    });
}])
.controller('TypeController', ['$scope', '$state', '$stateParams', 'Recipe', 'RecipeService', function($scope, $state, $stateParams, Recipe, RecipeService) {
    Recipe.query().$promise
    .then(function(data) {
        var restaurantUnitID = Number($scope.restaurantUnit().id);
        data = RecipeService.restrictedTenantFilter(data, restaurantUnitID);
        $scope.recipes = $stateParams.id ? _.filter(data, { type: { id: parseInt($stateParams.id) } }) : data;
        $scope.type = _.chain($scope.recipes).map('type').head().value();
        if( ! $scope.type) {
            $state.go('category', { id: '' });
        }
    });
}])
.controller('SearchController', ['$scope', '$timeout', 'Recipe', 'Allergen', 'RecipeService', function($scope, $timeout, Recipe, Allergen, RecipeService) {
    // Focus on the search field
    $timeout(function() {
        $(':input').filter('[ng-model="search"]').focus();
    }, 100);

    $scope.search = '';
    $scope.$watch('search', function(n) {
        var terms = _.chain(_.split(n, /\W+/))
        .filter(_.identity)
        .map(_.lowerCase)
        .value();
        
        var termLen = _.find(terms, function(t) { return _.size(t) > 1; }) && _.size(terms);
        
        var filter = function(i) {
            var name = i && _.lowerCase(i.name);
            var match = termLen > 0;
            for(var x = 0; x < termLen && match; x++) {
                match = match && name && name.indexOf(terms[x]) > -1;
            }
            return match;
        };
        
        // Recipes
        $scope.recipes = _.chain($scope.data)
        .filter(filter)
        .uniqBy('name')
        .value();
        
        // Recipe Types
        $scope.types = _.chain($scope.data)
        .map('type')
        .filter(filter)
        .uniqBy('name')
        .value();
        
        // Ingredients
        $scope.ingredients = _.chain($scope.data)
        .map(function(r) {
            return _.chain(r.ingredients)
            .filter(filter)
            .map(function(i) {
                return {
                    ingredient: i,
                    recipe: r
                };
            })
            .value();
        })
        .flatten()
        .filter(_.identity)
        .uniqBy(function(i) {
            return (i && i.ingredient && i.ingredient.name || '') + ':' + (i && i.recipe && i.recipe.name || '');
        })
        .value();
        
        
        // Allergens 
    
        var matchingAllergens =  _.filter($scope.allergenData, filter);
        
        var allergensRecipes = [];
        
        _.forEach(matchingAllergens, function(allergen){
            _.forEach(allergen.recipes, function(recipe){
                
                allergensRecipes.push({allergen: allergen, recipe: recipe});
                
            });
            
        });
        
        $scope.allergens = allergensRecipes;
 

    });
    Allergen.query().$promise
    .then(function(data) {
        $scope.allergenData = data;
    });
    Recipe.query({ includeIngredients: true }).$promise
    .then(function(data) {
        var restaurantUnitID = Number($scope.restaurantUnit().id);
        data = RecipeService.restrictedTenantFilter(data, restaurantUnitID);
        $scope.data = data;
    });
   
}])
.controller('SwitchController', ['$rootScope', '$scope', '$state', '$stateParams', 'RestaurantUnit', 'User', 'ConfigService', 'Feature', function($rootScope, $scope, $state, $stateParams, RestaurantUnit, User, ConfigService, Feature) {
    if($stateParams.id && $stateParams.name) {
        $scope.name = $stateParams.name;
        User.switchUnit({ lastUnitId: $stateParams.id }).$promise
        .then(function() {
            ConfigService.setRestaurantUnit({
                id: $stateParams.id,
                name: $stateParams.name
            });
            
        });
        
        Feature.query().$promise.then(function(results) {
            $scope.featureFlags = results;
            // Setting flag to true if feature flag is turned on for the unit
            $rootScope.showPrinterLabel = !!(_.find($scope.featureFlags, { "name":"PRINTER_LABEL", "active":true}));
            
            $state.go('category', { id: '' });
        });
        return;
    }
    
    $scope.search = '';

    RestaurantUnit.mine().$promise
    .then(function(data) {
        $scope.units = data;
    });
    
}])

/**
 * This method is run once, just after everything has been initialized.
 */
.run(['$rootScope', '$transitions', 'ConfigService', 'UnitService', 'ME_BUILD', 'AUTH0_CONFIG', 
    function($rootScope, $transitions, ConfigService, UnitService, ME_BUILD, AUTH0_CONFIG) {
    
    $rootScope.auth0Client = new auth0.Auth0Client({
        "domain": AUTH0_CONFIG.domain,
        "clientId": AUTH0_CONFIG.clientId,
        cacheLocation: 'localstorage'
    });

    // Prepare our configuration service
    ConfigService.init();
    if(ConfigService.getToken()) {
        UnitService.init();
    }
    
    // Setup a handler to dispose of lingering popovers if the user backs
    // out of a state.  Debounces events triggered over 200ms
    $transitions.onEnter({ }, _.debounce(function() {
        // Find all elements with a popover attribute and kill the popover
        $('[data-toggle="popover"]').popover('destroy');
    }), 200);

    // For referencing build-specific images
    $rootScope.buildUrl = ME_BUILD.url || '';
}]);
